import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import throttle from 'lodash/throttle'
import moment from 'moment'
import { withTranslation } from 'react-i18next'

import FavoriteActivity from 'app/domains/routes/FavoriteActivities/FavoriteActivitiesList/FavoriteActivity/index'
import Fire from 'app/components/SVGS/Fire'
import AvailableDomain from 'app/components/SVGS/AvailableDomain'
import Cross from 'react-icons/lib/fa/plus'

import './style.scss'

const bc = 'completed-activity'

const svgProps = {
  viewBox: '0 0 16 16',
  checkcolor: '#fff',
  background: '#2ED8A7',
  width: '32px',
  height: '32px',
}

export class CompletedActivity extends Component {
  static propTypes = {
    date: PropTypes.string,
    completedActivity: PropTypes.object,
    streak: PropTypes.bool,
    first: PropTypes.bool,
    last: PropTypes.bool,
    actionType: PropTypes.string,
    addActivityToFavorites: PropTypes.func,
    removeActivityFromFavorites: PropTypes.func,
    previousActionType: PropTypes.string,
  }

  state = {
    left: '162px',
  }

  componentDidMount = () => {
    this.handleResize = throttle(() => {
      const left = `${this.wrapSvg.offsetLeft + parseInt(getComputedStyle(this.wrapSvg).width) / 2 - 1}px`
      return this.setState({ left })
    }, 100)
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.handleResize)
  }

  render() {
    const {
      t,
      date,
      completedActivity,
      first,
      last,
      actionType,
      removeActivityFromFavorites,
      addActivityToFavorites,
      previousActionType,
    } = this.props
    const committed = actionType === 'commit'
    const streak = actionType === 'did'
    const isFire = (!first && streak) || (!first && committed)
    const isCross = !first && !streak
    return (
      <div className={bc}>
        <div className={`${bc}__date`}>{moment(date).format('Do, MMMM')}</div>
        <div
          ref={node => {
            this.wrapSvg = node
          }}
          className={cn(`${bc}__wrap-svg`, {
            [`${bc}__wrap-svg--domain`]: first,
            [`${bc}__wrap-svg--cross`]: isCross,
            [`${bc}__wrap-svg--fire`]: isFire,
          })}
        >
          <span
            className={cn({
              [`${bc}--domain`]: first,
              [`${bc}--cross`]: isCross,
              [`${bc}--fire`]: isFire,
            })}
          >
            {first ? <AvailableDomain {...svgProps} /> : streak || committed ? <Fire /> : <Cross />}
          </span>
        </div>
        {first ? (
          <div className={`${bc}__first-of-line`}>{t('Just Finished')}</div>
        ) : (
          <FavoriteActivity
            favoriteActivity={completedActivity.get('activity').toJS()}
            customClass={bc}
            actionType={actionType}
            removeFromFavorites={removeActivityFromFavorites}
            addToFavorites={addActivityToFavorites}
            isCompletedActivityBlock
          />
        )}
        <div
          style={{ left: this.state.left }}
          className={cn(`${bc}__line`, {
            [`${bc}__line--color-gray`]: !last,
            [`${bc}__line--color-gold`]:
              (previousActionType === 'did' || previousActionType === 'commit') && !last && isFire,
          })}
        />
      </div>
    )
  }
}

export default withTranslation('user')(CompletedActivity)
